module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Register","pageDesc":"Sign Up a Baianat Account"},"ar":{"pageTitle":"انشاء حساب","pageDesc":"سجل دخول لحسابك في بيانات"}}')
  delete Component.options._Ctor
}
